if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.section = this.closest('.js-product');
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');

      // Bind to on:variant:change event for this product
      this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy,
        this.dataset.inventoryEta      
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.getVariantInventory();
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy,
          inventory.inventory_eta
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy, inventoryEta) {
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      if (count <= 0) {
        if (available) {
          inventoryLevel = 'in_stock';
        } else if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else {
          inventoryLevel = 'none';
        }
/*
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
*/
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
            if (inventoryLevel === 'none' && inventoryEta !== '') {
              this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count) + this.formatInventoryArrival(inventoryEta);
            } else {
              this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
            }

        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock;
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          if (this.dataset.leadTime !== '') {
            this.inventoryNotice.innerText = 'Special Order Item - Delivery in ' + this.dataset.leadTime;;
          } else {
            this.inventoryNotice.innerText = this.dataset.showInStockLong === 'true' ? theme.strings.inStockLong : theme.strings.inStock;
          }
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          // Check if we should hide bar when well stocked
          if (this.dataset.hideBarWhenWellStocked === 'true' && (inventoryLevel === 'normal' || inventoryLevel === 'in_stock')) {
            this.indicatorBar.hidden = true;
          } else {
            this.indicatorBar.hidden = false;

            let newWidth;
            if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
              newWidth = 100;
            } else {
              newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
            }

            const barSpan = this.indicatorBar.querySelector('span');

            // Set the final width first
            barSpan.style.width = `${newWidth}%`;

            // Apply urgency animation if enabled and inventory is low/very_low
            if (this.dataset.animateBarAsUrgency === 'true' && (inventoryLevel === 'low' || inventoryLevel === 'very_low')) {
              // Remove the class first to trigger animation restart on variant changes
              barSpan.classList.remove('is-animating');
              // Trigger reflow to ensure animation restarts
              void barSpan.offsetWidth;
              // Add the animation class
              barSpan.classList.add('is-animating');
            } else {
              barSpan.classList.remove('is-animating');
            }
          }
        }
      } else {
        this.hidden = true;
      }
    }

    formatInventoryArrival(dateString) {
      if (!dateString) return " - Coming soon";

      const parts = dateString.split("-").map(Number);
      if (parts.length !== 3) return " - Coming soon";

      const [year, month, day] = parts;
      const date = new Date(year, month - 1, day);

      // Validate date correctness
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        return " - Coming soon";
      }

      // Compare against today (date-only)
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (date < today) return " - Coming soon";

      // Format for display
      return " - Estimated Arrival: " + new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      }).format(date);
    }

  }

  customElements.define('product-inventory', ProductInventory);
}
